import React, { useEffect, useState } from "react";
import RoleService from "../../../services/KangarooServices/RoleService";
import { Button, Card, CardBody, Col, Container, Row, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AddRole from "../Component/AddRole";
import RoleDetails from "./RoleDetails";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";

const Role = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [loading, setLoading] = useState(false);

  const toggleDetailModal = (id) => {
    setSelectedRoleId(id);
    setModalOpen(!modalOpen);
  };

  const toggleModal = (id = null) => {
    setSelectedRoleId(id);
    setIsOpen(!isOpen);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await RoleService.getList();
      setData(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDeleteClick = async (id) => {
    try {
      await RoleService.deleteRole(id);
      fetchData();
    } catch (error) {
      console.log(error);
    }
  };

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.9rem",
        fontWeight: 600,
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const filteredData = data.filter(
    (item) =>
      (item.name || "").toLowerCase().includes(filterText.toLowerCase()) ||
      (item.description || "").toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    {
      name: "S. No",
      cell: (row, index) => <div>{index + 1}</div>,
      width: "90px",
      className: "",
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      // width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      // width: "300px",
      wrap: true,
    },
    {
      name: "Actions",
      center: true,
      // width: "150px",
      cell: (row) => (
        <div className="d-flex gap-2">
          <Button
            size="sm"
            color="warning"
            className="btn-soft-warning "
            onClick={() => toggleModal(row.id)}
          >
            <i className="ri-pencil-line"></i>
          </Button>

          <Button
            size="sm"
            color="info"
            className="btn-soft-info "
            onClick={() => toggleDetailModal(row.id)}
          >
            <i className="ri-eye-line"></i>
          </Button>

          <Button
            size="sm"
            color="danger"
            className="btn-soft-danger "
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line"></i>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Roles" pageTitle="Content management" />

        <Row className="mb-4">
          <Col lg="6">
            <Input
              type="text"
              placeholder="Search by name or description..."
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </Col>
          <Col lg="6">
            <div className="d-flex justify-content-end">
              <button className="btn btn-success" onClick={() => toggleModal()}>
                <i className="ri-add-line align-bottom me-1"></i>
                Add Role
              </button>
            </div>
          </Col>
        </Row>

        {/* Desktop Table */}
        <Card className="d-none d-lg-block">
          <CardBody>
            <CustomDataTable
              columns={columns}
              data={filteredData}
              customStyles={customStyles}
              pagination
              striped
              responsive
              fixedHeader
              progressPending={loading}
            />
          </CardBody>
        </Card>

        {/* Mobile Cards */}
        {!loading &&
          filteredData.map((role, index) => (
            <Card key={role.id} className="d-block d-lg-none mb-3 shadow-sm">
              <CardBody>
                <h6>
                  <strong>Name:</strong> {role.name}
                </h6>
                <p className="mb-2">
                  <strong>Description:</strong> {role.description}
                </p>

                <div>
                  <Button
                    size="sm"
                    color="warning"
                    className="btn-soft-warning "
                    onClick={() => toggleModal(role.id)}
                  >
                    <i className="ri-pencil-line"></i>
                  </Button>

                  <Button
                    size="sm"
                    color="info"
                    className="btn-soft-info "
                    onClick={() => toggleDetailModal(role.id)}
                  >
                    <i className="ri-eye-line"></i>
                  </Button>

                  <Button
                    size="sm"
                    color="danger"
                    className="btn-soft-danger p-1"
                    onClick={() => handleDeleteClick(role.id)}
                  >
                    <i className="ri-delete-bin-5-line"></i>
                  </Button>
                </div>
              </CardBody>
            </Card>
          ))}

        <AddRole
          isOpen={isOpen}
          toggle={toggleModal}
          fetchData={fetchData}
          id={selectedRoleId}
        />

        <RoleDetails
          isOpen={modalOpen}
          toggle={toggleDetailModal}
          id={selectedRoleId}
        />
      </Container>
    </div>
  );
};

export default Role;
